/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculatorTask } from './CalculatorTask';
export type ExpenseItem = {
    id: string;
    name: string;
    type: ExpenseItem.type;
    value: number;
    quantity?: number | null;
    description?: string | null;
    tasks?: Array<CalculatorTask> | null;
};
export namespace ExpenseItem {
    export enum type {
        FIXED_ONETIME = 'fixed_onetime',
        FIXED_MONTHLY = 'fixed_monthly',
        FIXED_PROJECT = 'fixed_project',
        PER_UNIT = 'per_unit',
        PERCENTAGE_REVENUE = 'percentage_revenue',
        PERCENTAGE_REVENUE_MINUS_COMMISSION = 'percentage_revenue_minus_commission',
        PERCENTAGE_PROFIT = 'percentage_profit',
        KPI_TASKS = 'kpi_tasks',
    }
}

